// there are other properties in the model but this interface is only defined for reference
export const DEFAULT_EXTENSION = 'CSV';

export const getExportExtension = (): string => {
  return DEFAULT_EXTENSION;
};
